//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const IAM_AUTHR_API_BASE_URL = new InjectionToken<string>('IAM_AUTHR_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class IamAuthrApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IAM_AUTHR_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param cDCN_PersonId (optional) 
     * @param body (optional) 
     * @return Success
     */
    authorize22(cDCN_PersonId?: string | undefined, body?: AuthorizeRequest | undefined): Observable<AuthorizeResponse> {
        let url_ = this.baseUrl + "/api/Authorize/v2.2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "CDCN-PersonId": cDCN_PersonId !== undefined && cDCN_PersonId !== null ? "" + cDCN_PersonId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize22(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize22(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorizeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorizeResponse>;
        }));
    }

    protected processAuthorize22(response: HttpResponseBase): Observable<AuthorizeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthsignalActionUrl(body?: GetAuthsignalActionUrlCommand | undefined): Observable<AuthsignalActionUrlDto> {
        let url_ = this.baseUrl + "/api/Authsignal/getActionUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthsignalActionUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthsignalActionUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthsignalActionUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthsignalActionUrlDto>;
        }));
    }

    protected processGetAuthsignalActionUrl(response: HttpResponseBase): Observable<AuthsignalActionUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthsignalActionUrlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthsignalChallengeValidationStatus(body?: GetAuthsignalChallengeValidationStatusCommand | undefined): Observable<ValidateAuthsignalChallengeDto> {
        let url_ = this.baseUrl + "/api/Authsignal/getChallengeValidationStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthsignalChallengeValidationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthsignalChallengeValidationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateAuthsignalChallengeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateAuthsignalChallengeDto>;
        }));
    }

    protected processGetAuthsignalChallengeValidationStatus(response: HttpResponseBase): Observable<ValidateAuthsignalChallengeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateAuthsignalChallengeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMfaActivationStatus(): Observable<IActionResult> {
        let url_ = this.baseUrl + "/api/Mfa/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMfaActivationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMfaActivationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActionResult>;
        }));
    }

    protected processGetMfaActivationStatus(response: HttpResponseBase): Observable<IActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IActionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AuthorizeRequest implements IAuthorizeRequest {
    userObjectId?: string;
    apiName?: string | undefined;
    urlTemplate?: string | undefined;
    impersonatedPersonId?: string | undefined;
    method?: string | undefined;
    companyName?: string | undefined;
    currentRole?: string | undefined;

    constructor(data?: IAuthorizeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userObjectId = _data["userObjectId"];
            this.apiName = _data["apiName"];
            this.urlTemplate = _data["urlTemplate"];
            this.impersonatedPersonId = _data["impersonatedPersonId"];
            this.method = _data["method"];
            this.companyName = _data["companyName"];
            this.currentRole = _data["currentRole"];
        }
    }

    static fromJS(data: any): AuthorizeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userObjectId"] = this.userObjectId;
        data["apiName"] = this.apiName;
        data["urlTemplate"] = this.urlTemplate;
        data["impersonatedPersonId"] = this.impersonatedPersonId;
        data["method"] = this.method;
        data["companyName"] = this.companyName;
        data["currentRole"] = this.currentRole;
        return data;
    }
}

export interface IAuthorizeRequest {
    userObjectId?: string;
    apiName?: string | undefined;
    urlTemplate?: string | undefined;
    impersonatedPersonId?: string | undefined;
    method?: string | undefined;
    companyName?: string | undefined;
    currentRole?: string | undefined;
}

export class AuthorizeResponse implements IAuthorizeResponse {
    roles?: string[] | undefined;
    identityClaims?: IdentityClaims;
    companies?: string[] | undefined;

    constructor(data?: IAuthorizeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.identityClaims = _data["identityClaims"] ? IdentityClaims.fromJS(_data["identityClaims"]) : undefined as any;
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthorizeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["identityClaims"] = this.identityClaims ? this.identityClaims.toJSON() : undefined as any;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        return data;
    }
}

export interface IAuthorizeResponse {
    roles?: string[] | undefined;
    identityClaims?: IdentityClaims;
    companies?: string[] | undefined;
}

export class AuthsignalActionUrlDto implements IAuthsignalActionUrlDto {
    url?: string | undefined;

    constructor(data?: IAuthsignalActionUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AuthsignalActionUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthsignalActionUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IAuthsignalActionUrlDto {
    url?: string | undefined;
}

export class GetAuthsignalActionUrlCommand implements IGetAuthsignalActionUrlCommand {
    userId?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    action?: string | undefined;
    redirectUrl?: string | undefined;

    constructor(data?: IGetAuthsignalActionUrlCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.action = _data["action"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): GetAuthsignalActionUrlCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthsignalActionUrlCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["action"] = this.action;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IGetAuthsignalActionUrlCommand {
    userId?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    action?: string | undefined;
    redirectUrl?: string | undefined;
}

export class GetAuthsignalChallengeValidationStatusCommand implements IGetAuthsignalChallengeValidationStatusCommand {
    action?: string | undefined;
    token?: string | undefined;

    constructor(data?: IGetAuthsignalChallengeValidationStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetAuthsignalChallengeValidationStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthsignalChallengeValidationStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetAuthsignalChallengeValidationStatusCommand {
    action?: string | undefined;
    token?: string | undefined;
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIActionResult {
}

export class IdentityClaims implements IIdentityClaims {
    personId?: string | undefined;
    jobTitle?: string | undefined;
    roleName?: string | undefined;

    constructor(data?: IIdentityClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.jobTitle = _data["jobTitle"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): IdentityClaims {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityClaims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["jobTitle"] = this.jobTitle;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IIdentityClaims {
    personId?: string | undefined;
    jobTitle?: string | undefined;
    roleName?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ValidateAuthsignalChallengeDto implements IValidateAuthsignalChallengeDto {
    isChallengeSuccessful?: boolean;

    constructor(data?: IValidateAuthsignalChallengeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChallengeSuccessful = _data["isChallengeSuccessful"];
        }
    }

    static fromJS(data: any): ValidateAuthsignalChallengeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAuthsignalChallengeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChallengeSuccessful"] = this.isChallengeSuccessful;
        return data;
    }
}

export interface IValidateAuthsignalChallengeDto {
    isChallengeSuccessful?: boolean;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}